import React from 'react';
import styled from 'styled-components';

const Section = styled.section`
 
 
  box-sizing: border-box;
  width:100%;
  background-color:#1F1F1F;
  padding:5% 0% 5% 0%;

  @media (max-width: 500px) {
    padding:0% 0% 10% 0%;
  }

`;

const SectionWrapper = styled.section`
  box-sizing: border-box;
  width: 60%;
  margin: 0 auto;
  background-color: #1F1F1F;
  display: flex;
  flex-direction: column; /* 上下排列 */
  justify-content: space-between;

  @media (max-width: 500px) {
    width: 90%;
    padding: 0%;
  }
`;

const UpperSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 500px) {
    flex-direction: column; /* 寬度大於 500 時，改回左右排列 */
    justify-content: space-between;
  }
`;


const Title = styled.h2`
  text-align: left;
  font-style: normal;
  font-weight: 700;
  font-size: 48px;
  line-height: 70px;
  letter-spacing: 0.05em;
  color: #FFFFFF;
  padding: 0% 0% 2% 0%;
  width:70%;

  span {
    color: #FFF56A;
  }

  p {
    font-weight: 400;
    font-size: 18px;
    line-height: 32px;
    color: #AFAFAF;
  }

  @media (max-width: 500px) {
    width: 100%;
    font-weight: 700;
    font-size: 32px;
    line-height: 46px;
    padding: 5% 0% 0% 0%;
    text-align: center;
    margin-bottom:0px;

    p{
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
    }

  }
`;

const Button = styled.a`
  text-decoration: none;
  background-color:transparent;
  color:#FFFFFF;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0.05em;

  padding: 12px 40px;
  box-sizing: border-box;
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 100px;

  
  @media (max-width: 500px) {
    font-size: 14px;
    line-height: 24px;
    margin-top:0px;
    padding: 6px 20px;
    margin: 0 auto;

  }

  &:hover {
    background-color:#FFFFFF;
    color:#1f1f1f;
  }
`;

const LowerSection = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 24px;

  @media (max-width: 500px) {
    flex-direction: column;
  }
`;

const LeftImage = styled.img`
  width: 40%; /* 調整左邊圖片寬度 */
  height: auto;

  @media (max-width: 500px) {
    width: 100%;
    padding:10% 0% 0% 0%;
  }
`;

const RightImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (max-width: 500px) {
    width: 100%; 
  }
`;

const UpperImagesContainer = styled.div`
  display: flex;
  gap: 24px;
  width:50%;

  @media (max-width: 500px) {
    flex-direction: column; 
    width:100%;
  }
`;

const UpperImage = styled.img`
  width: 100%;
  height: auto;

  @media (max-width: 500px) {
    width: 100%; 
    height: auto;
  }
`;

const LowerImage = styled.img`
  width: 100%;
  height: auto;

  @media (max-width: 500px) {
    width: 100%; 
    height: auto;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (max-width: 500px) {
    flex-direction: row;
  }

`;

const Web3Section5 = () => (
  <Section>
    <SectionWrapper>
      <UpperSection>
        <Title>分散式公正服務驗證<br/>Tsenwen River Storyteller<span>.</span><p>河流具有重要的生態、文化和歷史價值，不僅是生命與文化的起源，而且還與身份、傳統和在地價值觀有著深遠的關係。河流孕育了城市的發展，看儘了各式個樣在其流域左右的故事。Tsenwen River Storyteller 曾文溪說書人是一個對話實驗，我們利用對話型 AI 建立一個 Interface for Care  作為人類與非人類溝通的文化轉譯者，超越以人為主的視角，將人的語言與萬物的語言對齊。這將有助於建立共鳴和理解，推動更具包容性、關係性和環保意識的民主系統，也驗證了分散式公證服務的技術可行性與未來性。</p></Title>
        <ButtonGroup>
          <Button href="https://rivercare-chat.plurality.moda.gov.tw" target="_blank" style={{ textDecoration: 'none' }}>開始對話</Button>
          <Button href="https://drive.google.com/file/d/1bRGBkevKEwcrUbLELyDY58i2eusXul5Y/view?usp=sharing" target="_blank" style={{ textDecoration: 'none' }}>閱讀更多</Button>
        </ButtonGroup>
      </UpperSection>
      <LowerSection>
        <LeftImage src="/images/Web3Sec5_1.png" alt="Left Image" />
        <RightImageContainer>
          <UpperImagesContainer>
            {/* 右上方左側圖片 */}
            <UpperImage src="/images/Web3Sec5_2.png" alt="Top Left Image" />
            {/* 右上方右側圖片 */}
            <UpperImage src="/images/Web3Sec5_3.png" alt="Top Right Image" />
          </UpperImagesContainer>
          {/* 右下方圖片 */}
          <LowerImage src="/images/Web3Sec5_4.png" alt="Bottom Right Image" />
        </RightImageContainer>
      </LowerSection>
    </SectionWrapper>
  </Section>
);

export default Web3Section5;
